import { useLenis } from "lenis/react";
import { CalendarCheck } from "lucide-react";
import { CALENDLY_URL, GRAD_BTN } from "@/components/Navbar";

const LINKS = [
  { label: "Fonctionnalités", href: "#fonctionnalites" },
  { label: "Offres", href: "#offres" },
  { label: "Nous contacter", href: "#contact" },
];

export const Footer = () => {
  const lenis = useLenis();

  return (
  <footer className="bg-ink pb-10 pt-20 text-white" data-testid="footer">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-6">
          <img
            src="/logo-white.png"
            alt="Syndicappli — La seule solution syndic à 360°"
            className="h-16 w-auto md:h-20"
            data-testid="footer-logo"
          />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/50">
            La Vie de votre Copro, à 360°. Gagnez du temps et de l'argent,
            adoptez Syndicappli.
          </p>
          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cta-demo-button"
            className={`mt-7 inline-flex items-center gap-3 rounded-full px-7 py-3.5 text-sm font-bold text-white shadow-[0_15px_35px_-12px_rgba(0,190,200,0.6)] transition-transform duration-300 hover:scale-105 active:scale-95 ${GRAD_BTN}`}
          >
            <CalendarCheck size={17} />
            Réserver une démo
          </a>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/40">
            Rubriques
          </p>
          <ul className="mt-5 space-y-3">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.href.replace("#", "")}`}
                  className="text-sm font-semibold text-white/70 transition-colors hover:text-white"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/40">
            Contact
          </p>
          <ul className="mt-5 space-y-3 text-sm font-semibold text-white/70">
            <li>
              <a href="tel:+33660976487" data-testid="footer-phone-link" className="transition-colors hover:text-white">
                +33 6 60 97 64 87
              </a>
            </li>
            <li>
              <a href="mailto:contact@syndicappli.fr" data-testid="footer-email-link" className="transition-colors hover:text-white">
                contact@syndicappli.fr
              </a>
            </li>
            <li>6, rue Léonard De Vinci<br />CS 20119, 53001 Laval</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-white/40 md:flex-row md:items-center">
        <p>© {new Date().getFullYear()} Syndicappli360 — Tous droits réservés.</p>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <a href="/mentions-legales" data-testid="footer-legal-mentions" className="transition-colors hover:text-white">
            Mentions légales
          </a>
          <a href="/politique-de-confidentialite" data-testid="footer-legal-privacy" className="transition-colors hover:text-white">
            Politique de confidentialité
          </a>
          <button
            onClick={() => {
              if (lenis) lenis.scrollTo(0);
              else window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            data-testid="footer-back-to-top"
            className="transition-colors hover:text-white"
          >
            Retour en haut
          </button>
          <a href="https://www.syndicappli.fr" target="_blank" rel="noopener noreferrer" data-testid="footer-app-link" className="transition-colors hover:text-white">
            app.syndicappli.fr
          </a>
        </div>
      </div>
    </div>
  </footer>
  );
};
